import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { isObject } from './is';
import { exposeClass } from '../styles/expose';
import cssAccessors, { cleanCache } from './css-accessors';
import { capitalize } from './strings';
import { entries } from './objects';
import { injectTag, cleanStyleObj, setThemeConfig } from './vars-inject';
var types = ['primary', 'warning', 'danger', 'success', 'secondary'];
var attrs = ['background', 'color', 'border'];

function validateFormat(data) {
  if (!isObject(data)) {
    console.error(new Error('Should enter a json data with attrs(key) and types(types)'));
    return false;
  } // attributes


  if (Object.keys(data).filter(function (v) {
    return attrs.indexOf(v) === -1;
  }).length > 0) {
    console.error(new Error("The attribute your entered does not exist need[".concat(attrs.join('/'), "]")));
    return false;
  } // types


  if (Object.values(data).filter(function (v) {
    return types.indexOf(v) === -1;
  }).length > 0) {
    console.error(new Error("The type your entered does not exist need[".concat(types.join('/'), "]")));
    return false;
  }

  return true;
}

function getClassname(data) {
  if (!validateFormat(data)) return '';
  return Object.keys(data).map(function (attr) {
    return exposeClass("".concat(data[attr], "-").concat(attr));
  }).join(' ');
}

function resetTheme() {
  Object.keys(cssAccessors).forEach(function (module) {
    var setterName = "set".concat(capitalize(module));
    var setter = cssAccessors[module][setterName];
    setter(Object.keys(cssAccessors[module]).reduce(function (obj, key) {
      obj[key] = undefined;
      return obj;
    }, {}));
  });
}

var defaultInjectType;

function getInjectType() {
  return defaultInjectType;
}

function setInjectType(type) {
  defaultInjectType = type;
}

function setStyle(options, custom) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    target: 'body'
  };
  var injectType = config.injectType || getInjectType() || 'body';
  setThemeConfig(_objectSpread2(_objectSpread2({}, config), {}, {
    injectType: injectType
  }));
  cleanStyleObj();

  if (!options) {
    resetTheme();
  } else {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = entries(options)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            values = _step$value[1];

        var setterName = "set".concat(capitalize(key));
        var module = cssAccessors[key];
        if (module && module[setterName]) module[setterName](values);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  if (injectType === 'tag') {
    var id = injectTag(custom);
    return function () {
      var target = document.getElementById(id);
      if (target) target.remove();
    };
  }

  return function () {};
}

var style = {
  getClassname: getClassname,
  setStyle: setStyle,
  cleanCache: cleanCache,
  setInjectType: setInjectType,
  getInjectType: getInjectType
};
var color = cssAccessors.color;
export { color, style, types };